export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">
            关于我们
          </h2>

          <div className="text-left space-y-4 text-sm text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-800">妖精动漫网</strong>是一个专注于免费漫画在线阅读的中文平台，
              致力于为漫画爱好者提供最新最全的<strong className="text-foreground-800">韩漫</strong>、
              <strong className="text-foreground-800">日漫</strong>和<strong className="text-foreground-800">国漫</strong>资源。
              我们深知每一位读者对漫画的热爱，因此始终坚持零门槛、全免费的阅读体验，让优质漫画触手可及。
            </p>

            <p>
              妖精动漫平台采用先进的下拉式阅读技术，无论是在手机、平板还是电脑上，都能享受流畅丝滑的翻页体验。
              平台每日同步更新热门连载，确保读者第一时间看到最新话。同时，收藏与追更功能的深度整合，让你再也不用担心错过任何更新。
            </p>

            <p>
              从热血格斗到恋爱甜宠，从奇幻冒险到悬疑推理，从武侠古风到科幻未来——
              妖精动漫覆盖全品类漫画类型，2000+部作品持续扩充中。无论你的口味如何，都能在这里找到属于自己的漫画世界。
            </p>

            <p>
              我们相信，好的漫画不应该被付费墙阻挡。妖精动漫网将始终秉持开放、免费、优质的运营理念，
              不断优化阅读体验、扩充漫画资源，努力成为中文漫画读者最信赖的在线阅读平台。
            </p>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">2000+</p>
              <p className="text-xs text-foreground-500 mt-1">漫画作品</p>
            </div>
            <div className="w-px h-10 bg-background-200"></div>
            <div className="text-center">
              <p className="text-2xl font-heading text-accent-500">每日更新</p>
              <p className="text-xs text-foreground-500 mt-1">更新频率</p>
            </div>
            <div className="w-px h-10 bg-background-200"></div>
            <div className="text-center">
              <p className="text-2xl font-heading text-primary-500">全免费</p>
              <p className="text-xs text-foreground-500 mt-1">阅读模式</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}